import { Component, input } from "@angular/core";
import { KpiItem, getStatusColor } from "../../../../../helpers/kpi/kpi-item";
import { CommonModule } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";

interface FormattedKpi {
  days: number;
  values: { value: number; kpi: KpiItem }[];
}

@Component({
  selector: "kpi-data",
  templateUrl: "kpi-data.html",
  styleUrls: ["../../kpi-table.scss"],
  imports: [CommonModule, MatTooltipModule, TranslateModule],
})
export class KpiData {
  title = input.required<string>();
  kpiItems = input.required<KpiItem[]>();
  kpiRows = input.required<FormattedKpi[]>();

  getStatus = getStatusColor;
}
